import { Component, Inject, OnInit } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-mensaje',
    templateUrl: './mensaje.component.html',
    styleUrls: [],
    standalone: false
})
export class MensajeComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<MensajeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    // This is intentional
  }

  onNoClick(): void {
    this.dialogRef.close(1);
  }

}